import { useEffect, useState } from "react";
import { ClipboardList, Download, PenLine, Sparkles } from "lucide-react";
import SectionHeader from "../eventsExperiences/SectionHeader";

const STEPS = [
  { icon: ClipboardList, title: "Brief", desc: "Share your product, audience, goal and where the content will run. We come back with questions, not a template." },
  { icon: PenLine, title: "Concept and script", desc: "You receive a script, storyboard and look reference to approve before any production begins." },
  { icon: Sparkles, title: "Create with AI", desc: "Visuals, voice, music and motion are generated, then refined, graded and cleaned up by our editors." },
  { icon: Download, title: "Review and deliver", desc: "Review the cut, ask for changes, and receive final files in every size and language you need." },
];

// Circle steps joined by wavy dashed lines; the active step walks through
// them on a loop (hover jumps to one) and lights up with its outgoing line.
const AiProcess = () => {
  const [active, setActive] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => setActive((a) => (a + 1) % STEPS.length), 2600);
    return () => clearInterval(timer);
  }, [active]); // hovering restarts the countdown

  return (
    <section className="ee-section ai-process">
      <div className="container">
        <SectionHeader
          eyebrow="Our process"
          title="How it"
          accent="works."
          intro="You approve the script, the storyboard and the final cut. Nothing goes live without your sign-off."
        />
        {/* AOS sits on this wrapper: its class never changes, so re-renders
            can't wipe AOS's visible class the way they would on each step. */}
        <div className="ai-steps" data-aos="fade-up" data-aos-once="true">
          {STEPS.map(({ icon: Icon, title, desc }, i) => (
            <article
              className={`ai-step${i === active ? " is-active" : ""}`}
              key={title}
              onMouseEnter={() => setActive(i)}
            >
              <div className="ai-step-circle">
                <span className="ai-step-num">{i + 1}</span>
                <span className="ai-step-icon">
                  <Icon size={24} strokeWidth={1.6} />
                </span>
              </div>
              {i < STEPS.length - 1 && (
                <svg className="ai-step-link" viewBox="0 0 100 30" preserveAspectRatio="none" aria-hidden="true">
                  <path d={i % 2 ? "M0 24 Q50 -10 100 24" : "M0 6 Q50 40 100 6"} />
                </svg>
              )}
              <h3>{title}</h3>
              <p>{desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AiProcess;
